import React from 'react';
import HeaderSmall from '../Components/Header/HeaderUnauthorized';
import { hashHistory } from 'react-router';
import { fireInAppBrowserPlugin } from './../actions/environmentActions';
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from './../utils/fetchUtil';

class EndPage extends React.Component {


    constructor(props){
        super(props);
        this.state = {
            content: {
                message: null,
                title: null,
                actions: null,
            },
        }
    }

    componentDidMount(){
        this.getContent();
    }

    getContent = () => {
        let config = {
            method: 'get',
            url: 'member/end/'
        }

        resourceApi(config)
        .then(r => {
            // let r = {
            //     message: "The HSG app is no longer available for HSG customers.  Please reach out directly to HSG for more information.",
            //     title: "Important Announcement For HSG Users",
            //     actions: `{"buttons":[{"url":"mailto:support@medefy.com", "label":"Contact HSG"}]}`,
            // }
            this.setState({content:{...r.data, Actions: JSON.parse(r.data.Actions)}});
        })
        .catch(e => {
            console.log(e)
            hashHistory.push('/?signout=true');
        });
    }

    returnFunction = () => {
        hashHistory.push('/?signout=true');
    }

    render() {

        let buttons = null;

        if(this.state.content && this.state.content.Actions && this.state.content.Actions.buttons){
            buttons = this.state.content.Actions.buttons
        }

        return (
            <div>
                <HeaderSmall goBackFunction={this.returnFunction} >
                    <span className="white" >Service Notice</span>
                </HeaderSmall>
                <div className="container" >
                    <br />
                    <br />
                    <div className={"endContainer"}>
                    {this.state.content != null && this.state.content.Title && (
                        <div className={"endTitle"}>
                            <h3 className="white" >{this.state.content.Title}</h3>
                        </div>
                    )}
                    {this.state.content != null && this.state.content.Message && (
                        <div className={"endMessage"}>
                            <span className="white" >{this.state.content.Message}</span>
                        </div>
                    )}
                    {buttons && buttons.length > 0 && buttons.map((a, i)=>(
                        <div className={"endActions"}>
                            <RaisedButton style= {{height:50}} fullWidth={true} primary={true} onClick={()=>{fireInAppBrowserPlugin(a.url)}} label={a.label} />
                        </div>
                    ))}
                    </div>
                </div>
            </div>
        );
    }
};

export default EndPage;


// WEBPACK FOOTER //
// ./src/Pages/End.js